import { Avatar } from '@chakra-ui/react'

interface InterviewerAvatarProps {
  photoURL?: string
  displayName: string
}

export const InterviewerAvatar = ({
  photoURL,
  displayName,
}: InterviewerAvatarProps) => (
  <Avatar
    src={photoURL || undefined}
    className="w-12 h-12"
    name={displayName}
  />
)
